import React, { Component } from "react";
import { connect } from "react-redux";

import {
  TimeOut,
  BreadCumb,
  NavBar,
  ConfigItemsDashboardModal,
  InventoryModal,
} from "../../components";
import {
  Datos_Empresa,
  points_Card,
  SERVICE_RESPONSE,
  superUser,
} from "../../libs/utils/Const";
import { ApiClient } from "../../libs/apiClient";
import config from "../../config";
import "../../css/dashboard.css";
import moment from "moment";
import $ from "jquery";
import { Redirect } from "react-router-dom";
import { development, Modules } from "../../libs/utils/Const";
const CryptoJS = require("crypto-js");

let apiClient = ApiClient.getInstance();

class HomeDashboardView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      counters: [],
      inventoryData: [],
      inventoryDataTotalRows: [],
      showInventoryModal: false,
      _user: JSON.parse(
        localStorage.getItem(config.localStorageNamed + "currentUser")
      ),
    };
  }

  async componentDidMount() {
    localStorage.setItem(
      config.localStorageNamed + "toogleNavBarItem",
      "liDash"
    );

    const today = moment(new Date()).format("YYYYMMDD");

    const date = {
      fechainicio: today,
      fechafinal: today,
    };
    const countResponse = await apiClient.getCountDocument(date);
    if (countResponse.status === SERVICE_RESPONSE.SUCCESS) {
      for (let index = 0; index < countResponse.data.length; index++) {
        const table = countResponse.data[index];
        $("#" + table.TableName).text(table.NumbersDocuments);
      }
      this.setState({
        counters: countResponse,
      });

      return;
    }
  }

  onAcceptConfig = () => {
    $("#configItemsDashboardModal").modal("hide");
  };

  onCancelConfig = () => {
    $("#configItemsDashboardModal").modal("hide");
  };

  toggleConfig = (index) => {
    let { itemsDashboard, counters } = this.state;
    itemsDashboard[index].active = !itemsDashboard[index].active;

    setTimeout(() => {
      for (let index = 0; index < counters.data.length; index++) {
        const table = counters.data[index];
        $("#" + table.TableName).text(table.NumbersDocuments);
      }
    }, 100);
    this.setState({
      itemsDashboard,
    });
  };

  openConfigItemsDashboard = () => {
    const itemsDashboard = JSON.parse(
      localStorage.getItem(config.localStorageNamed + "itemsDashboard")
    );
    this.setState({
      itemsDashboard,
    });
    $("#configItemsDashboardModal").modal("show");
  };

  openQuotations = () => {
    this.props.history.push("/quotations");
  };

  openOrderSales = () => {
    this.props.history.push("/orderSales");
  };

  openOrderSalesAuthorization = () => {
    this.props.history.push("/orderSalesAuthorization");
  };

  openBilling = () => {
    this.props.history.push("/billing");
  };

  openBillingBorrador = () => {
    this.props.history.push("/billingBorrador");
  };

  openBillingAuthorization = () => {
    this.props.history.push("/billingAuthorization");
  };

  openDeliveries = () => {
    this.props.history.push("/deliveries");
  };

  openDeliveriesAuhtorization = () => {
    this.props.history.push("/deliveriesAuthorization");
  };

  openReturn = () => {
    this.props.history.push("/return");
  };

  openPurchaseReturn = () => {
    this.props.history.push("/purchaseReturn");
  };

  openDebitNote = () => {
    this.props.history.push("/debitNote");
  };

  openCreditNote = () => {
    this.props.history.push("/creditNote");
  };

  openPayment = () => {
    this.props.history.push("/payment");
  };

  openTransfers = () => {
    this.props.history.push("/transfers");
  };

  openTransfersRequest = () => {
    this.props.history.push("/transfersRequest");
  };

  openTransfersEntry = () => {
    this.props.history.push("/transfersEntry");
  };

  openTransfersOutput = () => {
    this.props.history.push("/transfersOutput");
  };

  openInventoryRevaluation = () => {
    this.props.history.push("/inventoryRevaluation");
  };

  openBussinesPartner = () => {
    this.props.history.push("/bussinesPartner");
  };

  openInventoryData = () => {
    this.props.history.push("/inventoryData");
  };

  openMiddleware = () => {
    this.props.history.push("/middleware");
  };

  openQuery = () => {
    this.props.history.push("/query");
  };

  openPendingTimbreDocs = () => {
    this.props.history.push("/pendingTimbraDocs");
  };

  openPurchaseRequest = () => {
    this.props.history.push("/purchaseRequest");
  };

  openPurchaseOrder = () => {
    this.props.history.push("/purchaseOrder");
  };

  openGoodsReceipt = () => {
    this.props.history.push("/goodsReceipt");
  };

  openSalesHelmets = () => {
    this.props.history.push("/salesHelmets");
  };

  openExitHelmets = () => {
    this.props.history.push("/exitHelmets");
  };

  openPurchaseInvoice = () => {
    this.props.history.push("/purchaseInvoice");
  };

  openPurchaseDownPayments = () => {
    this.props.history.push("/purchaseDownPayments");
  };

  openPurchaseCreditNotes = () => {
    this.props.history.push("/purchaseCreditNotes");
  };

  openOutgoingPayments = () => {
    this.props.history.push("/outgoingPayments");
  };

  openCiti = () => {
    this.props.history.push("/citibanamex");
  };

  openTimbNom = () => {
    this.props.history.push("/timbraNom");
  };

  openEmployeeNom = () => {
    this.props.history.push("/employeeNom");
  };

  openinventoryReports = () => {
    this.props.history.push("/inventoryReports");
  };

  opeinvoiceAdvancePayment = () => {
    this.props.history.push("/invoiceAdvance");
  };

  opeinvoiceReserve = () => {
    this.props.history.push("/invoiceReserve");
  };

  openAdminUsers = () => {
    this.props.history.push("/adminUsers");
  };

  openPointOfSale = () => {
    this.props.history.push("/PointOfSale");
  };

  openSucursales = () => {
    this.props.history.push("/sucursales");
  };

  openGlobalConfig = () => {
    this.props.history.push("/globalConfig");
  };

  openInventory = () => {
    this.props.history.push("/inventory");
  };

  openReportSales = () => {
    this.props.history.push("/reportSales");
  };

  openPartnerDocuments = () => {
    this.props.history.push("/partnerDocuments");
  };

  openCollect = () => {
    this.props.history.push("/collect");
  };

  openRePrint = () => {
    this.props.history.push("/rePrint");
  };

  openBankDeposits = () => {
    this.props.history.push("/bankDeposits");
  };

  openClosures = () => {
    this.props.history.push("/closures");
  };

  openBranchClosures = () => {
    this.props.history.push("/branchClosures");
  };

  //#region CARTA PORTE
  openFiguraTransporte = () => {
    this.props.history.push("/figuraTransporte");
  };

  openTransporte = () => {
    this.props.history.push("/transporte");
  };

  openCartaPorte = () => {
    this.props.history.push("/cartaPorte");
  };
  //#endregion

  // OpenAdminR2D2 = () => {
  //   this.props.history.push("/R2D2");
  // };

  OpenAdminR2D2 = () => {
    this.props.history.push('/adminR2D2');
  };

  //#region M-SUITE
  openAdminSellersRoutes = () => {
    this.props.history.push("/adminSellersRoutes");
  };

  openDeliveriesAdminRoutes = () => {
    this.props.history.push("/adminDeliveries");
  };

  openBusinessPartnerAuthorization = () => {
    this.props.history.push("/authorizePartners");
  };

  openPointsCard = () => {
    this.props.history.push("/pointsCard");
  };

  openDeliveriesAdminRoutes20 = () => {
    this.props.history.push("/adminDeliveries20");
  };

  openNotificationManagement = () => {
    this.props.history.push('/notificationManagement');
  }
  openAdminPromo = () => {
    this.props.history.push('/PromotionManagement');
  }

  openLandedCosts = () => {
    this.props.history.push("/landedCosts");
  };

  openProductTree = () => {
    this.props.history.push("/productTree");
  };

  openProductionOrder = () => {
    this.props.history.push("/productionOrder");
  };

  openProvConfAssistant = () => {
    this.props.history.push("/provConfAssistant");
  };

  OpenRePrintTagsItems = () => {
    this.props.history.push("/printTagsItems");
  };

  openGoodsReceiptProd = () => {
    this.props.history.push("/goodsReceiptProd");
  };

  openGoodsIssue = () => {
    this.props.history.push("/goodsIssue");
  };

  openRscMasterData = () => {
    this.props.history.push("/rscMasterData");
  };

  openRscCapacity = () => {
    this.props.history.push("/rscCapacity");
  };

  //#region MRP
  openSalesForecast = () => {
    this.props.history.push('/salesForecast');
  };
  openMRPAssistant = () => {
    this.props.history.push('/mrpAssistant');
  };
  openReportSelectionCriteria = () => {
    this.props.history.push('/reportSelectionCriteria');
  };
  //endregion
  openDeliver = () => {
    this.props.history.push("/deliver");
  };

  openCutTransfers = () => {
    this.props.history.push("/CutTransfers");
  };

  //#region ######### referral system #########
  openAdminReferredSystem = () => {
    this.props.history.push('/adminReferredSystem');
  }
  openReferredPartners = () => {
    this.props.history.push('/referredPartners');
  }
  openAmbassadors = () => {
    this.props.history.push('/ambassadors');
  }
  //#endregion

  openLink = (link) => {
    this.props.history.push(link);
  }

  //#region ######### refill module #########
  openRefillModule = () => {
    this.props.history.push('/suggestedRefill');
  }
  //#endregion

  //#region M-VENTAS
  openmVAdminUsers = () => {
    this.props.history.push('/mVAdminUser');
  };
  openCanalizados = () => {
    this.props.history.push('/canalizadosAdmin');
  };
  //#endregion M-VENTAS
  /**WHS ADMIN */
  openWhsAdmin = () => {
    this.props.history.push("/Almacenes");
  };
  openReabsResume = () => {
    this.props.history.push("/ReabsResume");
  };
  // Navegación de la tarjeta del dashboard hacia el reporte de Soporte.
  openPendingCuts = () => {
    this.props.history.push("/PendingCuts");
  };

  OpenPriceList = () => {
    this.props.history.push("/priceLists");
  };

  openPurchaseQuotation = () => {
    this.props.history.push("/purchaseQuotation");
  };

  openDraft = () => {
    this.props.history.push("/draft");
  };

  //#region SUPPORT
  openReprocessDocumentsMVentas = () => {
    this.props.history.push("/ReprocessDocumentsMVentas");
  };
  openReprocessCeUso = () => {
    this.props.history.push("/ReprocessCeUso");
  };
  //#endregion SUPPORT

  render() {
    let itemsDashboard = JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard'));

    const { _user } = this.state;

    if (!itemsDashboard) {
      return <Redirect to="/login" />;
    }

    let bytes = CryptoJS.AES.decrypt(itemsDashboard, "exchange");
    itemsDashboard = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return (
      <div className="content">
        <NavBar props={this.props} _user={_user} />
        <BreadCumb subitem1={""} url1={""} />
        <TimeOut />
        {/* <ConfigItemsDashboardModal
                    dataConfig={itemsDashboard}
                    toggleChangeConfig={this.toggleConfig}
                    onAcceptConfig={this.onAcceptConfig}
                    onCancelConfig={this.onCancelConfig}/> */}

        <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
          <div className="search-div row" style={{ marginBottom: 50 }}>
            {/* <button className="btnItemsDashboard" onClick={this.openConfigItemsDashboard}
                                style={{fontWeight: '500', textAlign: 'left'}}>
                            Mostrar Elementos&nbsp;
                            <i className="fas fa-cog"></i>
                        </button> */}
          </div>

          <div className="row">
            {itemsDashboard["mktSales"] && itemsDashboard["mktSales"].active && (
              <div className="col-12 py-2">
                <div className="card">
                  <h3 className="card-title col-sm-12 text-center">
                    Documentos Ventas - Clientes
                  </h3>
                </div>
              </div>
            )}

            {itemsDashboard["quotations"] &&
              itemsDashboard["quotations"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openQuotations}
                >
                  <span routerlink="/quotations">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Oferta de Venta
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/quotations.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="OQUT" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["orderSales"] &&
              itemsDashboard["orderSales"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openOrderSales}
                >
                  <span routerlink="/orderSales">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Orden de Venta
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/orderSales.ico")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="ORDR" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["deliveries"] &&
              itemsDashboard["deliveries"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openDeliveries}
                >
                  <span routerlink="/deliveries">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Entrega
                        </h3>
                        <div className="card-text">
                          <hr />
                          <img
                            alt=""
                            src={require("../../images/ico/deliveries.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="ODLN" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["invoice"] && itemsDashboard["invoice"].active && (
              <div
                className="col-12 col-sm-6 col-lg-3 py-2"
                onClick={this.openBilling}
              >
                <span routerlink="/invoice">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Factura
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img
                          alt=""
                          src={require("../../images/ico/invoices.png")}
                          className="img-fluid icon-menu-dashboard"
                        />
                        <h2 id="OINV" className="contador-dash">
                          { }
                        </h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            )}

            {itemsDashboard["invoiceAdvance"] &&
              itemsDashboard["invoiceAdvance"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.opeinvoiceAdvancePayment}
                >
                  <span routerlink="/invoiceAdvance">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Factura de anticipo
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/invoices.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="ODPI" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["invoiceReserve"] &&
              itemsDashboard["invoiceReserve"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.opeinvoiceReserve}
                >
                  <span routerlink="/invoice">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Factura de Reserva de Clientes
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/invoices.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="OINVRI" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["debitNote"] && itemsDashboard["debitNote"].active && (
              <div
                className="col-12 col-sm-6 col-lg-3 py-2"
                onClick={this.openDebitNote}
              >
                <span routerlink="/debitNote">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Nota de Débito
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img
                          alt=""
                          src={require("../../images/ico/notaDebito.png")}
                          className="img-fluid icon-menu-dashboard"
                        />
                        <h2 id="OINVDN" className="contador-dash">
                          { }
                        </h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            )}

            {itemsDashboard["return"] && itemsDashboard["return"].active && (
              <div
                className="col-12 col-sm-6 col-lg-3 py-2"
                onClick={this.openReturn}
              >
                <span routerlink="/return">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Devolución
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img
                          alt=""
                          src={require("../../images/ico/devolucion.png")}
                          className="img-fluid icon-menu-dashboard"
                        />
                        <h2 id="ORDN" className="contador-dash">
                          { }
                        </h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            )}

            {itemsDashboard['creditNote'] && itemsDashboard['creditNote'].active &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openCreditNote}>
                <span routerlink="/creditNote">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Nota de Crédito
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/notaCredito.png')}
                          className="img-fluid icon-menu-dashboard" />
                        <h2 id="ORIN" className="contador-dash">{ }</h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {itemsDashboard['pendingTimbraDocs'] && itemsDashboard['pendingTimbraDocs'].active &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openPendingTimbreDocs}>
                <span routerlink="/autoF">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Documentos pendientes de timbrado <span id="bdgMonAlt"
                          className="badge badge-pill badge-info ml-2 dash-badge"></span>
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/quotations.png')}
                          className="img-fluid icon-menu-dashboard" />
                        <h2 id="PTDS" className="contador-dash"></h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {itemsDashboard['mktPurchase'] && itemsDashboard['mktPurchase'].active &&
              <div className="col-12 py-2" style={{ marginTop: 30 }}>
                <div className="card">
                  <h3 className="card-title col-sm-12 text-center">
                    Documentos de Compras - Proveedores
                  </h3>
                </div>
              </div>
            }

            {itemsDashboard["PurchaseRequest"] &&
              itemsDashboard["PurchaseRequest"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openPurchaseRequest}
                >
                  <span routerlink="/purchaseRequest">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Solicitud de Compra{" "}
                          <span
                            id="purchaseRequest"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/purchaseRequest.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="OPRQ" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["PurchaseQuotation"] &&
              itemsDashboard["PurchaseQuotation"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openPurchaseQuotation}
                >
                  <span routerlink="/purchaseQuotation">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Oferta de Compra{" "}
                          <span
                            id="purchaseQuotation"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/purchaseQuotation.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="OPQT" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["PurchaseOrder"] &&
              itemsDashboard["PurchaseOrder"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openPurchaseOrder}
                >
                  <span routerlink="/purchaseOrder">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Orden de Compra{" "}
                          <span
                            id="purchaseOrder"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/purchaseOrder.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="OPOR" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["GoodsReceipt"] &&
              itemsDashboard["GoodsReceipt"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openGoodsReceipt}
                >
                  <span routerlink="/goodsReceipt">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Entrada de Mercancía
                          <span
                            id="goodsReceipt"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/transfersEntry.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="OPDN" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["purchaseReturn"] &&
              itemsDashboard["purchaseReturn"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openPurchaseReturn}
                >
                  <span routerlink="/purchaseReturn">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Devolución de Mercancía
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/transfersOutput.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="ORPD" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["purchaseInvoice"] &&
              itemsDashboard["purchaseInvoice"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openPurchaseInvoice}
                >
                  <span routerlink="/purchaseInvoice">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Factura de Proveedores
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/invoices.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="OPCH" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["purchaseCreditNotes"] &&
              itemsDashboard["purchaseCreditNotes"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openPurchaseCreditNotes}
                >
                  <span routerlink="/purchaseCreditNotes">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Nota de crédito proveedores
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/purchaseCreditNotes.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="ORPC" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard['purchaseDownPayments'] && itemsDashboard['purchaseDownPayments'].active && Modules['PurchaseDownPayments'] && (
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openPurchaseDownPayments} >

                <div className="card h-100 ">
                  <div className="card-body">
                    <h3 className="card-title col-sm-12 text-right">
                      Factura de anticipo de Proveedores
                    </h3>
                    <hr />
                    <div className="card-text">
                      <img
                        alt="iconInvoices"
                        src={require("../../images/ico/invoices.png")}
                        className="img-fluid icon-menu-dashboard"
                      />
                      <h2 id="OPCH" className="contador-dash">
                        { }
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {itemsDashboard['landedCosts'] && itemsDashboard['landedCosts'].active &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openLandedCosts}>
                <span routerlink="/landedCosts">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Precios de Entrega
                        <span id="landedCosts" className="badge badge-pill badge-info ml-2 dash-badge"></span>
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/landedCosts.png')}
                          className="img-fluid icon-menu-dashboard" />
                        <h2 id="OIPF" className="contador-dash">{ }</h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }
            {/* BAND PRELIMINARES*/}
            {itemsDashboard['draftsHead'] && itemsDashboard['draftsHead'].active &&
              <div className="col-12 py-2" style={{ marginTop: 30 }}>
                <div className="card">
                  <h3 className="card-title col-sm-12 text-center">
                    Preliminares
                  </h3>
                </div>
              </div>
            }

            {itemsDashboard['drafts'] && itemsDashboard['drafts'].active &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openDraft}>
                <span routerlink="/draft">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Documentos Preliminares
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img
                          alt=""
                          src={require("../../images/ico/draft.png")}
                          className="img-fluid icon-menu-dashboard"
                        />
                        <h2 id="ODRF" className="contador-dash">
                          { }
                        </h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {/* BAND */}
            {['refillModule'].some(item => itemsDashboard[item]?.active) &&
              <div className="col-12 py-2" style={{ marginTop: 30 }}>
                <div className="card">
                  <h3 className="card-title col-sm-12 text-center">
                    Resurtido
                  </h3>
                </div>
              </div>
            }

            {itemsDashboard['refillModule'] && itemsDashboard['refillModule'].active &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openRefillModule}>
                <span>
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Sugerido de resurtido
                      </h3>
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/refillModule.png')}
                          className="img-fluid icon-menu-dashboard mt-3" style={{ width: "150px", marginTop: "14px" }} />
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {itemsDashboard["masterData"] &&
              itemsDashboard["masterData"].active && (
                <div
                  className="col-12 py-2"
                  style={{ marginTop: 30 }}
                >
                  <div className="card">
                    <h3 className="card-title col-sm-12 text-center">
                      Datos Maestros
                    </h3>
                  </div>
                </div>
              )}

            {itemsDashboard["bussinesPartner"] &&
              itemsDashboard["bussinesPartner"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openBussinesPartner}
                >
                  <span routerlink="/bussinesPartner">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Socio de Negocios
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/socionegocios.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id=" " className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["inventoryData"] &&
              itemsDashboard["inventoryData"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openInventoryData}
                >
                  <span routerlink="/inventoryData">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Datos de Artículo
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/trasladosEntry.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id=" " className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["banking"] && itemsDashboard["banking"].active && (
              <div
                className="col-12 py-2"
                style={{ marginTop: 30 }}
              >
                <div className="card">
                  <h3 className="card-title col-sm-12 text-center">
                    Gestión de Bancos
                  </h3>
                </div>
              </div>
            )}

            {itemsDashboard["payment"] && itemsDashboard["payment"].active && (
              <div
                className="col-12 col-sm-6 col-lg-3 py-2"
                onClick={this.openPayment}
              >
                <span routerlink="/payment">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Pagos Recibidos
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img
                          alt=""
                          src={require("../../images/ico/pagos.png")}
                          className="img-fluid icon-menu-dashboard"
                        />
                        <h2 id="ORCT" className="contador-dash">
                          { }
                        </h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            )}

            {itemsDashboard['outgoingPayment'] && itemsDashboard['outgoingPayment'].active &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openOutgoingPayments}>
                <span routerlink="/outgoingPayments">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Pagos Efectuados
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/pago.png')}
                          className="img-fluid icon-menu-dashboard" />
                        <h2 id="OVPM" className="contador-dash">{ }</h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {itemsDashboard['citibanamex'] && itemsDashboard['citibanamex'].active && development &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openCiti}>
                <span routerlink="/citibanamex">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Gestión Citibanamex
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/bank.png')}
                          className="img-fluid icon-menu-dashboard" />
                        <h2 id="CIBA" className="contador-dash">{ }</h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }


            {itemsDashboard['timbraNom'] && itemsDashboard['timbraNom'].active && Modules['TimbNominas'] && (
              <div className="col-12 py-2" style={{ marginTop: 30 }}>
                <div className="card">
                  <h3 className="card-title col-sm-12 text-center">
                    Nominas
                  </h3>
                </div>
              </div>
            )}

            {itemsDashboard['timbraNom'] && itemsDashboard['timbraNom'].active && Modules['TimbNominas'] &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openEmployeeNom}>
                <span>
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Empleados Nomina
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' style={{ height: '12vh' }} src={require('../../images/ico/employees.png')}
                          className="img-fluid icon-menu-dashboard" />
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {itemsDashboard['timbraNom'] && itemsDashboard['timbraNom'].active && Modules['TimbNominas'] &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openTimbNom}>
                <span >
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Timbrado de nominas
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' style={{ height: '12vh' }} src={require('../../images/ico/timbNomina.png')}
                          className="img-fluid icon-menu-dashboard" />
                        {/* <h2 className="contador-dash">{ }</h2> */}
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {itemsDashboard['inventoryData'] && itemsDashboard['inventoryData'].active &&
              <div className="col-12 py-2" style={{ marginTop: 30 }}>
                <div className="card">
                  <h3 className="card-title col-sm-12 text-center">
                    Datos de Inventario
                  </h3>
                </div>
              </div>
            }

            {itemsDashboard["transfersRequest"] &&
              itemsDashboard["transfersRequest"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openTransfersRequest}
                >
                  <span routerlink="/transfers">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Solicitud de traslado
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/transfersRequest.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="OWTQ" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["transfers"] && itemsDashboard["transfers"].active && (
              <div
                className="col-12 col-sm-6 col-lg-3 py-2"
                onClick={this.openTransfers}
              >
                <span routerlink="/transfers">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Traslado de Mercancía
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img
                          alt=""
                          src={require("../../images/ico/traslados.png")}
                          className="img-fluid icon-menu-dashboard"
                        />
                        <h2 id="OWTR" className="contador-dash">
                          { }
                        </h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            )}

            {itemsDashboard["transfersEntry"] &&
              itemsDashboard["transfersEntry"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openTransfersEntry}
                >
                  <span routerlink="/transfers">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Entrada de Mercancía
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/transfersEntry.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="OIGN" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["transfersOutput"] &&
              itemsDashboard["transfersOutput"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openTransfersOutput}
                >
                  <span routerlink="/transfers">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Salida de Mercancía
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/transfersOutput.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="OIGE" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {((itemsDashboard['inventoryCounting'] && itemsDashboard['inventoryCounting'].active) && Modules.InventoryCounting) &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={() => this.openLink("/inventoryCounting")}>
                <span routerlink="/inventoryCounting">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Recuento de inventario
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/notaCredito.png')}
                          className="img-fluid icon-menu-dashboard" />
                        <h2 id="OINC" className="contador-dash">{ }</h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {((itemsDashboard['inventoryPosting'] && itemsDashboard['inventoryPosting'].active) && Modules.InventoryCounting) &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={() => this.openLink("/inventoryPosting")}>
                <span routerlink="/inventoryPosting">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Contabilización de stocks
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/quotations.png')}
                          className="img-fluid icon-menu-dashboard" />
                        <h2 id="OIQR" className="contador-dash">{ }</h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {itemsDashboard["printTagsItems"] &&
              itemsDashboard["printTagsItems"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.OpenRePrintTagsItems}
                >
                  <span routerlink="/printTagsItems">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Impresión de etiquetas
                          <span className="badge badge-pill badge-info ml-2 dash-badge" />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/printingTag.png")}
                            className="img-fluid icon-menu-dashboard mt-3"
                            style={{ width: "115px", marginTop: "14px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["priceList"] &&
              itemsDashboard["priceList"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.OpenPriceList}
                >
                  <span routerlink="/priceLists">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Listas de Precios
                          <span className="badge badge-pill badge-info ml-2 dash-badge" />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/PriceLists.png")}
                            className="img-fluid icon-menu-dashboard mt-3"
                            style={{ width: "115px", marginTop: "14px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["inventoryRevaluation"] &&
              itemsDashboard["inventoryRevaluation"].active &&
              false && (
                <div
                  className="col-sm-12 col-md-3 py-2"
                  onClick={this.openInventoryRevaluation}
                >
                  <span routerlink="/inventoryRevaluation">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Revalorización de Inventario
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/trasladosEntry.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="OMRV" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {false &&
              itemsDashboard["stockAudit"] &&
              itemsDashboard["stockAudit"].active && (
                <div
                  className="col-sm-12 col-md-3 py-2"
                  onClick={this.openinventoryReports}
                >
                  <span routerlink="/inventoryReports">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Informe de Auditoría de Stocks
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/trasladosEntry.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id=" " className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["wareHouseAdmin"] && itemsDashboard["wareHouseAdmin"].active && (
              <div id="WHSAdminDashboard" className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openWhsAdmin}>
                <span routerlink="/whsAdmin">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Admin. Almacén
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img
                          alt=""
                          src={require("../../images/ico/inventory-management.png")}
                          className="img-fluid icon-menu-dashboard"
                        />
                        <h2 id="OWHS" className="contador-dash">
                          { }
                        </h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            )}



            {['rscMasterData', 'rscCapacity'].some(item => itemsDashboard[item]?.active) &&
              <div className="col-12 py-2" style={{ marginTop: 30 }}>
                <div className="card">
                  <h3 className="card-title col-sm-12 text-center">
                    Recursos
                  </h3>
                </div>
              </div>
            }

            {itemsDashboard['rscMasterData'] && itemsDashboard['rscMasterData'].active &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openRscMasterData}>
                <span routerlink="/rscMasterData">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Datos maestros del recurso
                        <span id="rscMasterData" className="badge badge-pill badge-info ml-2 dash-badge"></span>
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/rscMasterData.png')}
                          className="img-fluid icon-menu-dashboard" />
                        <h2 id="ORSC" className="contador-dash">{ }</h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {itemsDashboard['rscCapacity'] && itemsDashboard['rscCapacity'].active &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openRscCapacity}>
                <span routerlink="/rscCapacity">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Capacidad de recursos
                        <span id="rscCapacity" className="badge badge-pill badge-info ml-2 dash-badge"></span>
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/rscCapacity.png')}
                          className="img-fluid icon-menu-dashboard" />
                        <h2 id="" className="contador-dash">{ }</h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {['productTree', 'productionOrder', 'goodsReceiptProd', 'goodsIssue'
              // , 'provConfAssistant'
            ].some(item => itemsDashboard[item]?.active) &&
              <div className="col-12 py-2" style={{ marginTop: 30 }}>
                <div className="card">
                  <h3 className="card-title col-sm-12 text-center">
                    Producción
                  </h3>
                </div>
              </div>
            }

            {itemsDashboard['productTree'] && itemsDashboard['productTree'].active &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openProductTree}>
                <span routerlink="/productTree">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Lista de Materiales
                        <span id="productTree" className="badge badge-pill badge-info ml-2 dash-badge"></span>
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/productTree.png')}
                          className="img-fluid icon-menu-dashboard" />
                        <h2 id="OITT" className="contador-dash">{ }</h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {itemsDashboard["productionOrder"] &&
              itemsDashboard["productionOrder"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openProductionOrder}
                >
                  <span routerlink="/productionOrder">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Orden de Fabricación
                          <span
                            id="productionOrder"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/productionOrder.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="OWOR" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}


            {itemsDashboard["goodsIssue"] &&
              itemsDashboard["goodsIssue"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openGoodsIssue}
                >
                  <span routerlink="/goodsIssue">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Emisión para producción
                          <span
                            id="goodsIssue"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/goodsIssue.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="OIGE" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["goodsReceiptProd"] &&
              itemsDashboard["goodsReceiptProd"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openGoodsReceiptProd}
                >
                  <span routerlink="/goodsReceiptProd">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Recibo de producción
                          <span
                            id="goodsReceiptProd"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/goodsReceiptProd.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="OIGN" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {false && itemsDashboard['provConfAssistant'] && itemsDashboard['provConfAssistant'].active &&
              <div className="col-sm-12 col-md-3 py-2" onClick={this.openProvConfAssistant}>
                <span routerlink="/provConfAssistant">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Asistente de confirmación de aprovisionamiento
                        <span id="provConfAssistant" className="badge badge-pill badge-info ml-2 dash-badge"></span>
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/provConfAssistant.png')}
                          className="img-fluid icon-menu-dashboard" />
                        <h2 id="" className="contador-dash">{ }</h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {itemsDashboard["inzi"] && itemsDashboard["inzi"].active && (
              <div
                className="col-12 py-2"
                style={{ marginTop: 30 }}
              >
                <div className="card">
                  <h3 className="card-title col-sm-12 text-center">
                    Autorizaciones
                  </h3>
                </div>
              </div>
            )}

            {itemsDashboard["invoiceAuthorization"] &&
              itemsDashboard["invoiceAuthorization"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openBillingAuthorization}
                >
                  <span routerlink="/invoiceAuthorization">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Documentos por Autorizar
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/invoicesAuthorization.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="OWDD" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard['invoiceBorrador'] && itemsDashboard['invoiceBorrador'].active &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openBillingBorrador}>
                <span routerlink="/invoiceBorrador">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Documentos Autorizados Pendientes
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/invoicesBorrador.png')}
                          className="img-fluid icon-menu-dashboard" />
                        <h2 id="ODRFOINV" className="contador-dash1">{ }</h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {true &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openBusinessPartnerAuthorization}>
                <span routerlink="/invoiceAuthorization">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Autorizaciones de Socios de negocios
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/socionegocios.png')}
                          className="img-fluid icon-menu-dashboard" />
                        <h2 className="contador-dash">{ }</h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {((itemsDashboard['salesForecast'] && itemsDashboard['salesForecast'].active) ||
              (itemsDashboard['mrpAssistant'] && itemsDashboard['mrpAssistant'].active) ||
              (itemsDashboard['reportSelectionCriteria'] && itemsDashboard['reportSelectionCriteria'].active)) &&
              <div className="col-12 py-2" style={{ marginTop: 30 }}>
                <div className="card">
                  <h3 className="card-title col-sm-12 text-center">
                    Planes de adquisición - MRP
                  </h3>
                </div>
              </div>
            }

            {itemsDashboard['salesForecast'] && itemsDashboard['salesForecast'].active &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openSalesForecast}>
                <span routerlink="/quotations">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Previsiones
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/notaCredito.png')}
                          className="img-fluid icon-menu-dashboard" />
                        <h2 id=" " className="contador-dash">{ }</h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {itemsDashboard["mrpAssistant"] &&
              itemsDashboard["mrpAssistant"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openMRPAssistant}
                >
                  <span routerlink="/orderSales">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Asistente MRP
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            width="128px"
                            src={require("../../images/ico/NUEVOS_CHOFERES.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id=" " className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard['reportSelectionCriteria'] && itemsDashboard['reportSelectionCriteria'].active &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openReportSelectionCriteria}>
                <span routerlink="/deliveries">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Recomendación de pedido
                      </h3>
                      <div className="card-text">
                        <hr />
                        <img alt='' src={require('../../images/ico/purchaseRequest.png')}
                          className="img-fluid icon-menu-dashboard" />
                        <h2 id=" " className="contador-dash">{ }</h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {itemsDashboard['actions'] && itemsDashboard['actions'].active &&
              <div className="col-12 py-2" style={{ marginTop: 30 }}>
                <div className="card">
                  <h3 className="card-title col-sm-12 text-center">
                    Acciones Internas
                  </h3>
                </div>
              </div>
            }

            {itemsDashboard["administratorUsers"] &&
              itemsDashboard["administratorUsers"].active &&
              (superUser ||
                (_user &&
                  _user?.E_Mail &&
                  (_user.E_Mail === Datos_Empresa.CorreoAdminUser ||
                    _user?.E_Mail === "desarrollo2@fmbsolutions.mx" ||
                    _user?.E_Mail === "desarrollo1@fmbsolutions.mx" ||
                    _user?.E_Mail === "vic@fmb.com")) ||
                _user?.E_Mail === "manager@llamagas.com") && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openAdminUsers}
                >
                  <span routerlink="/adminUsers">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Admin. de usuarios{" "}
                          <span
                            id="bdgMonAlt"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/adminUsers.png")}
                            className="img-fluid icon-menu-dashboard mt-3"
                            style={{ width: "120px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["sucursales"] &&
              itemsDashboard["sucursales"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openSucursales}
                >
                  <span routerlink="/sucursales">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Sucursales{" "}
                          <span
                            id="bdgMonAlt"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/sucursal.png")}
                            className="img-fluid icon-menu-dashboard mt-3"
                            style={{ width: "115px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["globalConfig"] &&
              itemsDashboard["globalConfig"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openGlobalConfig}
                >
                  <span routerlink="/globalConfig">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Config. Global{" "}
                          <span
                            id="bdgMonAlt"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/globalServices.png")}
                            className="img-fluid icon-menu-dashboard mt-3"
                            style={{ width: "120px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["queryManager"] &&
              itemsDashboard["queryManager"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openQuery}
                >
                  <span routerlink="/autoF">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Consultas{" "}
                          <span
                            id="bdgMonAlt"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/query.png")}
                            className="img-fluid icon-menu-dashboard mt-2"
                            style={{ width: "130px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {(superUser ||
              (_user &&
                _user?.E_Mail &&
                (_user.E_Mail === Datos_Empresa.CorreoAdminUser ||
                  _user?.E_Mail === "desarrollo1@fmbsolutions.mx" ||
                  _user?.E_Mail === "manager@llamagas.com" ||
                  _user?.E_Mail === "desarrollo2@fmbsolutions.mx" ||
                  _user?.E_Mail === "vic@fmb.com"))) && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.OpenAdminR2D2}
                >
                  <span routerlink="/adminUsers">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          R2D2{" "}
                          <span
                            id="bdgMonAlt"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            width="128px"
                            src={require("../../images/ico/botSettings.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id=" " className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {false &&
              itemsDashboard["middleware"] &&
              itemsDashboard["middleware"].active && (
                <div
                  className="col-sm-12 col-md-3 py-2"
                  onClick={this.openMiddleware}
                >
                  <span routerlink="/autoF">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Middleware{" "}
                          <span
                            id="bdgMonAlt"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/auto.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["administratorUsers"] &&
              itemsDashboard["administratorUsers"].active &&
              (superUser ||
                (_user &&
                  _user?.E_Mail &&
                  (_user.E_Mail === Datos_Empresa.CorreoAdminUser ||
                    _user?.E_Mail === "desarrollo2@fmbsolutions.mx" ||
                    _user?.E_Mail === "desarrollo1@fmbsolutions.mx")) ||
                _user?.E_Mail === "desarrollo2@fmbsolutions.mx") && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openNotificationManagement}
                >
                  <span routerlink="/notificationManagement">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Admin. de notificaciones{" "}
                          <span
                            id="bdgMonAlt"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/notificationManagement.png")}
                            className="img-fluid icon-menu-dashboard mt-3"
                            style={{ width: "120px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["adminSchedule"] &&
              itemsDashboard["adminSchedule"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openAdminPromo}
                >
                  <span routerlink="/notificationManagement">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Admin. Horarios{" "}
                          <span
                            id="bdgMonAlt"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/settings.png")}
                            className="img-fluid icon-menu-dashboard mt-3"
                            style={{ width: "120px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {/* CARTA PORTE */}
            {itemsDashboard["consignmentNoteManagement"] &&
              itemsDashboard["consignmentNoteManagement"].active && (
                <div
                  className="col-12 py-2"
                  style={{ marginTop: 30 }}
                >
                  <div className="card">
                    <h3 className="card-title col-sm-12 text-center">
                      Gestión de Cartas Porte
                    </h3>
                  </div>
                </div>
              )}
            {/* Gestion de FiguraTransporte */}
            {itemsDashboard["figuresTransport"] &&
              itemsDashboard["figuresTransport"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openFiguraTransporte}
                >
                  <span routerlink="/figuraTransporte">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Figuras Transporte
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            width="128px"
                            src={require("../../images/ico/NUEVOS_CHOFERES.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id=" " className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {/* Gestion de Transportes */}
            {itemsDashboard["transports"] &&
              itemsDashboard["transports"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openTransporte}
                >
                  <span routerlink="/transporte">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Transportes
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            width="128px"
                            src={require("../../images/ico/NUEVOS_CAMIONES.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id=" " className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {/* Gestion de Carta porte  */}
            {itemsDashboard["consignmentNote"] &&
              itemsDashboard["consignmentNote"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openCartaPorte}
                >
                  <span routerlink="/cartaPorte">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Carta Porte
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            width="128px"
                            src={require("../../images/ico/NUEVOS_CARTA_PORTE.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                          <h2 id="OCPT" className="contador-dash">
                            { }
                          </h2>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["counter"] && itemsDashboard["counter"].active && (
              <div
                className="col-12 py-2"
                style={{ marginTop: 30 }}
              >
                <div className="card">
                  <h3 className="card-title col-sm-12 text-center">
                    Punto de venta
                  </h3>
                </div>
              </div>
            )}

            {itemsDashboard['pointSales'] && itemsDashboard['pointSales'].active &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openPointOfSale}>
                <span routerlink="/POS">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Venta de Mostrador <span id="bdgMonAlt"
                          className="badge badge-pill badge-info ml-2 dash-badge"></span>
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/pos.png')}
                          className="img-fluid icon-menu-dashboard mt-3" />
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {itemsDashboard['counterReturns'] && itemsDashboard['counterReturns'].active &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={() => this.openLink("/counterReturns")}>
                <span routerlink="/POS">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title"> Devolución y/o Cancelaciones </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/devolu.png')} className="img-fluid icon-menu-dashboard mt-3" style={{ width: 147 }} />
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {/* {itemsDashboard['settingsPS'].active  &&
                            <div className="col-sm-12 col-md-3 py-2" onClick={this.openSettings}>
                                <span routerlink="/settings">
                                    <div className="card h-100 ">
                                        <div className="card-body">
                                            <h3 className="card-title col-sm-12 text-right">
                                                Configuraciones <span id="bdgMonAlt"
                                                    className="badge badge-pill badge-info ml-2 dash-badge"></span>
                                            </h3>
                                            <hr />
                                            <div className="card-text">
                                                <img alt='' src={require('../../images/ico/settings.png')}
                                                    className="img-fluid icon-menu-dashboard" />
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        } */}

            {itemsDashboard["inventoryPS"] &&
              itemsDashboard["inventoryPS"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openInventory}
                >
                  <span routerlink="/inventory">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Inventario{" "}
                          <span
                            id="bdgMonAlt"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/inventario.png")}
                            className="img-fluid icon-menu-dashboard mt-3"
                            style={{ maxWidth: "115px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["reportsPS"] && itemsDashboard["reportsPS"].active && (
              <div
                className="col-12 col-sm-6 col-lg-3 py-2"
                onClick={this.openReportSales}
              >
                <span routerlink="/reportSales">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Reportes{" "}
                        <span
                          id="bdgMonAlt"
                          className="badge badge-pill badge-info ml-2 dash-badge"
                        />
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img
                          alt=""
                          src={require("../../images/ico/reportes.png")}
                          className="img-fluid icon-menu-dashboard mt-3"
                          style={{ width: "115px" }}
                        />
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            )}

            {itemsDashboard["partnerDocuments"] &&
              itemsDashboard["partnerDocuments"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openPartnerDocuments}
                >
                  <span routerlink="/partnerDocuments">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-12 text-right">
                          {" "}
                          Documentos por Cliente{" "}
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/quotations.png")}
                            className="img-fluid icon-menu-dashboard mt-3"
                            style={{ width: "115px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["payments"] && itemsDashboard["payments"].active && (
              <div
                className="col-12 col-sm-6 col-lg-3 py-2"
                onClick={this.openCollect}
              >
                <span routerlink="/collect">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Cobranza{" "}
                        <span
                          id="bdgMonAlt"
                          className="badge badge-pill badge-info ml-2 dash-badge"
                        />
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img
                          alt=""
                          src={require("../../images/ico/cobranza.png")}
                          className="img-fluid icon-menu-dashboard mt-3"
                          style={{ width: "115px" }}
                        />
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            )}

            {itemsDashboard["incomingPaymentsPS"] &&
              itemsDashboard["incomingPaymentsPS"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openBankDeposits}
                >
                  <span routerlink="/bankDeposits">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Depósitos bancarios{" "}
                          <span
                            id="bdgMonAlt"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/depositos.png")}
                            className="img-fluid icon-menu-dashboard mt-3"
                            style={{ width: "115px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["prints"] && itemsDashboard["prints"].active && (
              <div
                className="col-12 col-sm-6 col-lg-3 py-2"
                onClick={this.openRePrint}
              >
                <span routerlink="/rePrint">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Re-impresión
                        <span
                          id="bdgMonAlt"
                          className="badge badge-pill badge-info ml-2 dash-badge"
                        />
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img
                          alt=""
                          src={require("../../images/ico/impresion.png")}
                          className="img-fluid icon-menu-dashboard mt-3"
                          style={{ width: "115px", marginTop: "14px" }}
                        />
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            )}

            {itemsDashboard["closuresPS"] &&
              itemsDashboard["closuresPS"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openClosures}
                >
                  <span routerlink="/closures">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Cierres y cortes
                          <span
                            id="bdgMonAlt"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/close.png")}
                            className="img-fluid icon-menu-dashboard mt-3"
                            style={{ width: "115px", marginTop: "14px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard["branchClosuresPS"] &&
              itemsDashboard["branchClosuresPS"].active &&
              _user !== null &&
              _user !== undefined &&
              _user?.USER_CODE &&
              _user?.USER_CODE === "manager" && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openBranchClosures}
                >
                  <span routerlink="/branchClosures">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          Cierres de sucursal
                          <span
                            id="bdgMonAlt"
                            className="badge badge-pill badge-info ml-2 dash-badge"
                          />
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/close.png")}
                            className="img-fluid icon-menu-dashboard mt-3"
                            style={{ width: "115px", marginTop: "14px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}

            {itemsDashboard['pointsCard'] && itemsDashboard['pointsCard'].active && points_Card &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openPointsCard}>
                <span routerlink="/closures">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Monedero Electrónico
                        <span id="bdgMonAlt" className="badge badge-pill badge-info ml-2 dash-badge"></span>
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/pointsCard.png')}
                          className="img-fluid icon-menu-dashboard mt-3" style={{ width: "115px", marginTop: "14px" }} />
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {false && itemsDashboard[0] && itemsDashboard[0].active &&
              <div className="col-sm-12 col-md-12 py-2" style={{ marginTop: 30 }}>
                <div className="card">
                  <h3 className="card-title col-sm-12 text-center">
                    Cascos
                  </h3>
                </div>
              </div>
            }

            {false && itemsDashboard[0] && itemsDashboard[0].active && (
              <div
                className="col-sm-12 col-md-3 py-2"
                onClick={this.openSalesHelmets}
              >
                <span routerlink="/salesHelmets">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Entrada de Mercancía Cascos
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img
                          alt=""
                          src={require("../../images/ico/transfersEntry.png")}
                          className="img-fluid icon-menu-dashboard"
                        />
                        <h2 id="OIGNN" className="contador-dash">
                          { }
                        </h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            )}

            {false && itemsDashboard[0] && itemsDashboard[0].active &&
              <div className="col-sm-12 col-md-3 py-2" onClick={this.openExitHelmets}>
                <span routerlink="/exitHelmets">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Salida de Mercancía Cascos
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/transfersOutput.png')}
                          className="img-fluid icon-menu-dashboard" />
                        <h2 id="OIGEE" className="contador-dash">{ }</h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {itemsDashboard["deliver"] && itemsDashboard["deliver"].active && (
              <div
                className="col-12 col-sm-6 col-lg-3 py-2"
                onClick={this.openDeliver}
              >
                <span routerlink="/deliver">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Entregas de Fact. de reserva
                        <span
                          id="bdgMonAlt"
                          className="badge badge-pill badge-info ml-2 dash-badge"
                        />
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img
                          alt=""
                          src={require("../../images/ico/entregas_black.png")}
                          className="img-fluid icon-menu-dashboard mt-3"
                          style={{ width: "115px" }}
                        />
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            )}

            {itemsDashboard["cutTransfers"] && itemsDashboard["cutTransfers"].active && (
              <div id="cutTransfers" className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openCutTransfers}>
                <span routerlink="/CutTransfers">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Traspaso de Cortes
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img
                          alt=""
                          src={require("../../images/ico/invoicesBorrador.png")}
                          className="img-fluid icon-menu-dashboard"
                        />
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            )}

            {/* BAND */}
            {['ambassadors', 'referredPartners', 'adminReferredSystem'].some(item => itemsDashboard[item]?.active) &&
              <div className="col-12 py-2" style={{ marginTop: 30 }}>
                <div className="card">
                  <h3 className="card-title col-sm-12 text-center">
                    Sistema de referidos
                  </h3>
                </div>
              </div>
            }

            {itemsDashboard['adminReferredSystem'] && itemsDashboard['adminReferredSystem'].active &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openAdminReferredSystem}>
                <span>
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Administrador de referidos
                        <span className="badge badge-pill badge-info ml-2 dash-badge"></span>
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/referredAdmin.png')}
                          className="img-fluid icon-menu-dashboard mt-3" style={{ width: "115px", marginTop: "14px" }} />
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {itemsDashboard['ambassadors'] && itemsDashboard['ambassadors'].active &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openAmbassadors}>
                <span>
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Embajadores
                        <span className="badge badge-pill badge-info ml-2 dash-badge"></span>
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/ambassadors.png')}
                          className="img-fluid icon-menu-dashboard mt-3" style={{ width: "115px", marginTop: "14px" }} />
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {itemsDashboard['referredPartners'] && itemsDashboard['referredPartners'].active &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openReferredPartners}>
                <span routerlink="/closures">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Referidos
                        <span className="badge badge-pill badge-info ml-2 dash-badge"></span>
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/referredPartners.png')}
                          className="img-fluid icon-menu-dashboard mt-3" style={{ width: "115px", marginTop: "14px" }} />
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {/*####################################### ADMIN SELLERS ROUTES ###################################### */}
            {/* BAND */}
            {(itemsDashboard['adminSellersRoutes'] && itemsDashboard['adminSellersRoutes'].active) &&
              <div className="col-12 py-2" style={{ marginTop: 30 }}>
                <div className="card">
                  <h3 className="card-title col-sm-12 text-center">
                    Admin. Rutas de Vendedores
                  </h3>
                </div>
              </div>
            }

            {(itemsDashboard['adminSellersRoutes'] && itemsDashboard['adminSellersRoutes'].active) &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openAdminSellersRoutes}>
                <span routerlink="/adminSellersRoutes">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        ADMINISTRADOR RUTAS DE VENDEDORES <span id="bdgMonAlt"
                          className="badge badge-pill badge-info ml-2 dash-badge"></span>
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/routeSellers.png')}
                          className="img-fluid icon-menu-dashboard" style={{ maxWidth: "112px", marginTop: "14px" }} />
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {/* #end region */}


            {/*####################################### ADMIN DELIVERIES ###################################### */}
            {/* BAND */}
            {itemsDashboard["adminDeliveriesRoutes"] &&
              itemsDashboard["adminDeliveriesRoutes"].active && (
                <div
                  className="col-12 py-2"
                  style={{ marginTop: 30 }}
                >
                  <div className="card">
                    <h3 className="card-title col-sm-12 text-center">
                      Administrador de Entregas
                    </h3>
                  </div>
                </div>
              )}
            {/* MODULES IN */}
            {itemsDashboard["adminDeliveriesRoutes"] &&
              itemsDashboard["adminDeliveriesRoutes"].active && (
                <div
                  className="col-12 col-sm-6 col-lg-3 py-2"
                  onClick={this.openDeliveriesAdminRoutes20}
                >
                  <span routerlink="/adminDeliveries">
                    <div className="card h-100 ">
                      <div className="card-body">
                        <h3 className="card-title col-sm-12 text-right">
                          GESTOR DE ENTREGAS FÍSICAS
                        </h3>
                        <hr />
                        <div className="card-text">
                          <img
                            alt=""
                            src={require("../../images/ico/transfersOutput.png")}
                            className="img-fluid icon-menu-dashboard"
                          />
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}
            {/* M-VENTAS */}
            {itemsDashboard['mVentas'] && itemsDashboard['mVentas'].active &&
              <div className="col-12 py-2" style={{ marginTop: 30 }}>
                <div className="card">
                  <h3 className="card-title col-sm-12 text-center">
                    Gestión M-Ventas
                  </h3>
                </div>
              </div>
            }

            {((itemsDashboard['mAdminUser'] && itemsDashboard['mAdminUser'].active) || superUser) &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openmVAdminUsers}>
                <span routerlink="/mVAdminUser">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Admin. de usuarios M-VENTAS <span id="bdgMonAlt"
                          className="badge badge-pill badge-info ml-2 dash-badge"></span>
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/adminUsers.png')}
                          className="img-fluid icon-menu-dashboard mt-3" style={{ width: "120px" }} />
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }

            {((itemsDashboard['canalizadoAdmin'] && itemsDashboard['canalizadoAdmin'].active) || superUser) &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openCanalizados}>
                <span routerlink="/mVAdminUser">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Canalizados <span id="bdgMonAlt"
                          className="badge badge-pill badge-info ml-2 dash-badge"></span>
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/gas.png')}
                          className="img-fluid icon-menu-dashboard mt-3" style={{ width: "120px" }} />
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }
            {/* ----END------  M-VENTAS */}

            {/* SOPORTE */}
            {itemsDashboard['support'] && itemsDashboard['support'].active &&
              <div className="col-12 py-2" style={{ marginTop: 30 }}>
                <div className="card">
                  <h3 className="card-title col-sm-12 text-center">
                    Soporte
                  </h3>
                </div>
              </div>
            }
            {/* {((itemsDashboard['mVentasReprocess'] && itemsDashboard['mVentasReprocess'].active)) &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openReprocessDocumentsMVentas}>
                <span routerlink="/mVAdminUser">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        {itemsDashboard?.['mVentasReprocess']?.tit ?? '--'} <span id="bdgMonAlt"
                          className="badge badge-pill badge-info ml-2 dash-badge"></span>
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/invoices.png')}
                          className="img-fluid icon-menu-dashboard mt-3" style={{ width: "120px" }} />
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            }
            {((itemsDashboard['ceUsoReProcess'] && itemsDashboard['ceUsoReProcess'].active)) &&
              <div className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openReprocessCeUso}>
                <span routerlink="/mVAdminUser">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        {itemsDashboard?.['ceUsoReProcess']?.tit ?? '--'} <span id="bdgMonAlt"
                          className="badge badge-pill badge-info ml-2 dash-badge"></span>
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img alt='' src={require('../../images/ico/ceuso.png')}
                          className="img-fluid icon-menu-dashboard mt-3" style={{ width: "120px" }} />
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            } */}
            {itemsDashboard["reabsResume"] && itemsDashboard["reabsResume"].active && (
              <div id="reabsResume" className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openReabsResume}>
                <span routerlink="/ReabsResume">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Reabastecimiento
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img
                          alt=""
                          src={require("../../images/ico/traslados.png")}
                          className="img-fluid icon-menu-dashboard"
                        />
                        <h2 id="TRAB" className="contador-dash">
                          { }
                        </h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            )}
            {/* Renderiza la tarjeta solo cuando los metadatos/permisos habilitan el módulo. */}
            {itemsDashboard["pendingCuts"]?.active && (
              <div id="pendingCuts" className="col-12 col-sm-6 col-lg-3 py-2" onClick={this.openPendingCuts}>
                <span routerlink="/PendingCuts">
                  <div className="card h-100 ">
                    <div className="card-body">
                      <h3 className="card-title col-sm-12 text-right">
                        Cortes Pendientes
                      </h3>
                      <hr />
                      <div className="card-text">
                        <img
                          alt=""
                          src={require("../../images/ico/corteC.png")}
                          className="img-fluid icon-menu-dashboard"
                          style={{ width: "80px" }}
                        />
                        {/* No se consulta contador aquí; el reporte muestra su total después de buscar. */}
                        <h2 id="PENDCUTS" className="contador-dash">
                          { }
                        </h2>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            )}
            {/* ----END------ SOPORTE */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomeDashboardView);
